export default "__VITE_ASSET__CPOLCGM$__ 1200w";